<template>
  <div class="characteristic">
    <div class="characteristic__head">
      <Icon :name="iconName" />
      <Heading size="h5">
        {{ title }}
      </Heading>
    </div>
    <Paragraph class="characteristic__body">
      <slot />
    </Paragraph>
  </div>
</template>

<script>
import Icon from '@/components/common/Icon/Icon'
import Heading from '@/components/common/Heading/Heading'
import Paragraph from '@/components/common/Paragraph/Paragraph'

export default {
  components: {
    Icon,
    Heading,
    Paragraph
  },

  props: {
    iconName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.characteristic {
  display: flex;

  flex-direction: column;
  gap: $gap * 0.5;

  &__head {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: $gap * 0.5;
    border-left: 2px solid $colorLightPurple;
    padding: 0 $gap;
  }

  &__body {
    padding: 0 $gap;
  }
}
</style>
